import React, { useCallback } from 'react';
import { EButtonVariant } from './enums';
import { cn } from 'utils';

interface CustomButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: EButtonVariant;
  label: string;
  prefixIcon?: JSX.Element;
  suffixIcon?: JSX.Element;
  className?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  variant,
  label,
  prefixIcon,
  suffixIcon,
  className,
  ...props
}) => {
  const getButtonClassName = useCallback((variant: string) => {
    if (variant === EButtonVariant.PRIMARY) {
      return 'text-white bg-[#1D67B6] hover:bg-[#3480D1]';
    }

    return '';
  }, []);

  switch (variant) {
    case EButtonVariant.PRIMARY:
      return (
        <button
          className={cn(
            className,
            'rounded-[12px] flex items-center justify-center gap-x-1 py-[10px]',
            getButtonClassName(variant)
          )}
          {...props}
        >
          {prefixIcon}
          {label}
          {suffixIcon}
        </button>
      );
    default:
      return <button {...props}>{label}</button>;
  }
};

export default CustomButton;
